import { render, staticRenderFns } from "./Actually.vue?vue&type=template&id=49b0a35a&scoped=true&"
import script from "./Actually.vue?vue&type=script&lang=js&"
export * from "./Actually.vue?vue&type=script&lang=js&"
import style0 from "./Actually.vue?vue&type=style&index=0&id=49b0a35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b0a35a",
  null
  
)

export default component.exports